const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/DashboardButtonCard.tsx';
import * as React from 'react';
import { ReactNode } from 'react';
import Icon from '@mui/material/Icon';
import { css, cx } from '@emotion/css';
import { Button, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid';
import LoadingSpinner from '@cistec/common_web/components/LoadingSpinner';
import { fullWidth } from '../Components/appointmentCards/styles';

const buttonCss = css`
    height: 50px;
`;

const buttonIconCss = css`
    display: inline-block;
    margin-right: 8px;
`;

type Props = {
    children: ReactNode;
    iconClass: string;
    onClick: () => void;
    hasData?: boolean;
    isDataLoading?: boolean;
};

export const DashboardButtonCard = (props: Props) => {
    const hasData = props.hasData ?? true;
    const isDataLoading = props.isDataLoading ?? false;

    if (isDataLoading) {
        return (
            <Card>
                <CardContent>
                    <LoadingSpinner />
                </CardContent>
            </Card>
        );
    }

    if (!hasData) return null;

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                <Button
                    variant="contained"
                    color="primary"
                    className={cx(fullWidth, buttonCss)}
                    onClick={props.onClick}
                >
                    <Icon className={cx(props.iconClass, buttonIconCss)} component="span" />
                    {props.children}
                </Button>
            </Card>
        </Grid>
    );
};
